import {useEffect, useState} from "react";
import styled from 'styled-components';

import {useParams} from "react-router-dom";
import useFeedback from "../../../utils/use_feedback";
import {useSaveClicked} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {useCommunityStylesheet, useSaveStylesheet} from "../../../api/communities";
import {Textarea, useToast} from "@chakra-ui/react";

const StylesheetCommunitySettings = styled(({className}) => {
    const {community} = useParams();
    const {error, feedbackCh} = useFeedback();

    const [code, setCode] = useState('');
    useCommunityStylesheet(feedbackCh, community, setCode);

    const saveStylesheet = useSaveStylesheet(feedbackCh);
    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    const toast = useToast();
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    toast({
                        title: `Saving...`,
                        status: 'info',
                        isClosable: true,
                    });
                    await saveStylesheet(community, code);
                    toast.closeAll();
                    toast({
                        title: `Saved settings.`,
                        status: 'success',
                        isClosable: true,
                    });
                    setSaving(false);
                }
            }
        })().then(() => {
        }, () => {
        });
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Community Stylesheet" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>
                    <p>Stylesheet is an advanced setting which only effects desktop clients - proceed with caution.</p>
                    <Textarea
                        value={code}
                        language="css"
                        placeholder="/* CSS goes here */"
                        fontSize={"15px"}
                        onChange={(evn) => setCode(evn.target.value)}
                        minHeight={380}
                    />
                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  p {
    font-size: 15px;
    padding-bottom: 12px;
  }
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
`;

export default StylesheetCommunitySettings;
